/** Facts about this device and how the app is running on it. */

export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

/** Opened from the home screen / as an installed app, rather than in a browser tab. */
export const isStandalone = () =>
  matchMedia('(display-mode: standalone)').matches || (navigator as { standalone?: boolean }).standalone === true;
